import styled from 'styled-components';

export const CloseIcon = styled.img`
  width: 14px;
  align-self: flex-end;
  cursor: pointer;
`;

export const Container = styled.div`
  width: 820px;
  margin: 30px auto;
  padding: 20px 10px;
  font-family: 'Inter', sans-serif;
  color: #222;
  font-size: 14px;
`;

export const Heading = styled.h5`
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 10px;
`;

export const Separator = styled.div`
  width: 100%;
  height: 1px;
  background-color: #dcdcdc; /* light gray line */
  margin: 0 auto 20px auto;
`;

export const Row = styled.div`
  display: flex;
  margin-bottom: 18px;
  align-items: flex-start;
`;

export const Label = styled.div`
  width: 180px;
  font-weight: 600;
  flex-shrink: 0;
`;

export const ValueGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px; /* spacing between multiple values */
`;

export const Value = styled.div`
  line-height: 1.5;
`;

export const TitleValue = styled(Value)`
  font-weight: 600;
  margin-top: 6px;
`;
